import request from '../utils/fetch'

export function ApplicationList (data) {
  return request({
    url: '/withdrawalApplication/ApplicationList',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}
export function changeApplication (data) {
  return request({
    url: '/withdrawalApplication/changeApplication',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}
export function customerApplicationList (data) {
  return request({
    url: '/customerIncomeRecord/ApplicationList',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}
export function customerChangeApplication (data) {
  return request({
    url: 'customerIncomeRecord/changeApplication',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}



